import { css, useTheme } from "@emotion/react";
import clsx from "clsx";

import useClickable from "./useClickable.jsx";
import useThemeProps from "./useThemeProps.jsx";

// const LinkRoot = styled("a")`
//   color: ${(props) => props.theme.getColor(props.color || "primary.600")};
//   text-decoration: ${(props) =>
//     props.underline === "default" ? "underline" : "none"};
//   &:hover {
//     text-decoration: ${(props) =>
//       props.underline === "default" ? "none" : "underline"};
//   }
// `;

// const LinkRootInert = styled("span")``;

export default function Link(props) {
  const theme = useTheme();
  props = useThemeProps({
    props,
    name: "Link",
    handleVariant: true,
  });
  let {
    Element,
    type,
    props: { underline = "default", color = null, className, ...restProps },
  } = useClickable(props);

  // let Component = type === "inert" ? LinkRootInert : LinkRoot;
  return (
    <Element
      // underline={underline}
      data-link-type={type}
      {...restProps}
      className={clsx("wsui-link", className)}
      css={css`
        --link-color: ${color && theme.getColor(color)};
        color: var(--link-color, inherit);
        text-decoration: ${underline === "default" ? "underline" : "none"};
        &:hover {
          text-decoration: ${underline === "default" ? "none" : "underline"};
        }
      `}
    />
  );
}
